<div class="cell-view">
  <div class="inner-view">{{ filterTags(rowData[fieldName]) }}</div>
  <div *ngIf="editable; else readonly" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="MultilineCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit('RichText', !editable)"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="MultilineCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
  <ng-template #readonly>
    <div class="edit-menu">
      <button
        pButton
        id="cancelRowSelection"
        data-cy="MultilineCell_Button_edit"
        icon="pi pi-eye"
        (click)="onEdit('RichText', !editable)"
      ></button>
    </div>
  </ng-template>
</div>
